// extracted by mini-css-extract-plugin
module.exports = {"buttons":"DriverForm_buttons__2Igfs","form":"DriverForm_form__26SYt","required":"DriverForm_required__17mqR"};